import React, { createContext, useEffect, useState } from 'react';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { Autocomplete, Box, Button, Card, Chip, FormControl, FormControlLabel, FormLabel, Grid, IconButton, MenuItem, Modal, Radio, RadioGroup, Select, Stack, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { useForm, FormProvider } from 'react-hook-form';
import dayjs from 'dayjs';
import { CouponServices } from './CouponServices';
import Swal from 'sweetalert2';
import calculateAspectRatio from '../../../utils/calculateRatio';
import Loading from '../../../components/Loader/Loading';
// import ImageSection from './ImageSection';
import CouponForm from './CouponForm';
import isExpired from '../../../utils/checkCouponExpiry';


const CouponDataContext = createContext();
const AddEditCoupon = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const initialState = {
        title: '',
        description: '',
        couponCode: '',
        couponType: 'fixed',//fixed or percentage
        couponValue: '',
        minimumBookingAmt: 0,
        maximumDiscount: 0,
        startDate: '',
        endDate: '',
        limitPerUser:'',
        selectedCustomers: [],
        status: true,
        generatedBy:'manual'
    }
    const [couponData, setCouponData] = useState(initialState);
    const CouponFormMethod = useForm({
        mode: 'onChange',
        defaultValues: couponData
    });
    const { control, watch, handleSubmit, setValue, formState: { isDirty, errors, dirtyFields }, reset } = CouponFormMethod;
    const fetchCouponData = async () => {
        const response = await CouponServices.getCouponById(id);
        if (response.success == '1') {
            setCouponData(response.data);
            reset(response.data);
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.message,
            });
        }
    }
    useEffect(() => {
        if (id > 0) {
            fetchCouponData();
        }
    }, [id])

    const handleFormSubmit = async (data) => {
        console.log('Form data:', data);
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `You want to ${id>0 ? 'update selected': 'create new '} coupon?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowOutsideClick: false,
        })
        if (result.isConfirmed) {
            Swal.fire({
                title: 'Processing...',
                text: `Please wait while ${id>0?'updtaing selected coupon':'creating new Coupon' }`,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            try {
                if(id>0){
                    const updateResponse = await CouponServices.updateCoupon(id,data);
                    if (updateResponse.success == "1") {
                        await Swal.fire({
                            title: 'Success',
                            text: 'Coupon data updated successfully',
                            icon: 'success',
                            confirmButtonText: 'OK',
                            timer: 1600,
                        });

                        navigate(`/marketing/coupon/view/${id}`);
                    } else {
                        await Swal.fire({
                            title: 'Failed',
                            text: updateResponse.message || 'Coupon Updation Failed',
                            icon: 'error',
                            confirmButtonText: 'OK',
                        });
                    }
                }else{
                    const createResponse = await CouponServices.addCoupon(data);
                    if (createResponse.status == "success") {
                        await Swal.fire({
                            title: 'Success',
                            text: 'Coupon created successfully',
                            icon: 'success',
                            confirmButtonText: 'OK',
                            timer: 1600,
                        });
                        navigate('/marketing/coupons');
                    } else {
                        await Swal.fire({
                            title: 'Failed',
                            text: createResponse.message || 'Coupon creation Failed',
                            icon: 'error',
                            confirmButtonText: 'OK',
                        });
                    }
                }
            } catch (error) {
                console.error('Error submitting coupon:', error);
            }
        }
    }

    return (
        <CouponDataContext.Provider value={{ couponData, setCouponData }}>
            <PageHeaderLayout headerTitle={id > 0 ? `Edit Coupon Detail's` : 'Add New Coupon'}>
                <Button variant='contained' onClick={() => navigate(-1)} size='small' startIcon={<ArrowBack />}>
                    Back
                </Button>
            </PageHeaderLayout>
            <FormProvider {...CouponFormMethod}>
                <Box component={'form'} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Card sx={{ p: 2 }}>
                                <CouponForm />
                                {id>0 && isExpired(couponData.endDate) ? null:
                                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                                        <Button disabled={!isDirty} size='small' variant='contained' color='primary' onClick={handleSubmit(handleFormSubmit)} sx={{ mt:'2%',fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                            {id>0 ? 'Update':'Save'}
                                        </Button>
                                    </Grid>
                                }
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            </FormProvider>
        </CouponDataContext.Provider>
    );
}

export default AddEditCoupon;
export { CouponDataContext };